import { format } from "date-fns";

import { Calendar } from "@livechat/design-system-icons";

import {
  CustomDateRangeFilterId,
  DateRangeFilterFormattedValues,
  IDateRangeWithCompareFilter,
} from "constants/filters";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const dateRangeFilterConfig: IFilterConfig = {
  title: "Date",
  icon: Calendar,
  multiple: false,
  getFilterLabelValues: (filterValues: IDateRangeWithCompareFilter | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      // @ts-expect-error TS(2322): Type 'null' is not assignable to type 'IFilterLabe... Remove this comment to see the full error message
      return null;
    }

    let label: string;
    if (filterValues.id !== CustomDateRangeFilterId.CustomPeriod || !filterValues.from || !filterValues.to) {
      // @ts-expect-error TS(7053)
      label = DateRangeFilterFormattedValues[filterValues.id];
    } else {
      label = `${format(filterValues.from, "YYYY-MM-DD")} - ${format(filterValues.to, "YYYY-MM-DD")}`;
    }

    return [
      {
        key: filterValues.id,
        label,
      },
    ];
  },
};
